import { Alert, SimpleGrid, Stack } from '@mantine/core';
import { mapApiToTccData } from './helpers';
import { useDashboardSectionData } from '../hooks/useDashboardSectionData';
import { PerformanceCardSkeleton } from '../PerformanceCardSkeleton';
import { CredentialsAwardedCard } from './cards/CredentialsAwardedCard';
import { EmploymentCard } from './cards/EmploymentCard';
import { GraduatesCard } from './cards/GraduatesCard';
import { MultipleCredentialsCard } from './cards/MultipleCredentialsCard';
import { ParticipantsCard } from './cards/ParticipantsCard';

export function TccPerformanceMetrics() {
  const { mappedData: tccData, error, isLoading } = useDashboardSectionData({
    queryKey: 'tcc',
    fallbackGroupId: 'TCC',
    enabled: (group) => group === 'TCC',
    mapData: mapApiToTccData,
  });

  return (
    <Stack spacing="lg">
      {error ? (
        <Alert color="yellow" variant="light">
          Unable to load dashboard API data.
        </Alert>
      ) : null}
      {!isLoading && !tccData ? (
        <Alert color="yellow" variant="light">
          No dashboard API data returned for this section.
        </Alert>
      ) : null}
      {isLoading && !tccData ? (
        <>
          <PerformanceCardSkeleton />
          <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: 980, cols: 1 }]}>
            <PerformanceCardSkeleton />
            <PerformanceCardSkeleton />
            <PerformanceCardSkeleton />
            <PerformanceCardSkeleton />
          </SimpleGrid>
        </>
      ) : null}
      {tccData ? (
        <>
          <ParticipantsCard data={tccData} />
          <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: 980, cols: 1 }]}>
            <GraduatesCard data={tccData} />
            <MultipleCredentialsCard data={tccData} />
            <CredentialsAwardedCard data={tccData} />
            <EmploymentCard data={tccData} />
          </SimpleGrid>
        </>
      ) : null}
    </Stack>
  );
}
